import { useState } from 'react'
import {
  AccordionData,
  ContentType,
  LucideIconName,
} from '@bm-js/atlascloud-shared'
import { Icon } from './Icon'

type Props = { content: ContentType<AccordionData> }

export const AccordionContent = ({ content }: Props) => {
  const [expanded, setExpanded] = useState(false)
  return (
    <div
      className={`bg-white shadow-[0px_1px_3px_rgba(16,24,40,0.1),0px_1px_2px_rgba(16,24,40,0.06)]`}
      style={{ marginBottom: content.data.marginBottom }}
    >
      <div
        className='flex cursor-pointer items-center justify-between px-[0.9rem] py-[0.6rem]'
        onClick={() => setExpanded(!expanded)}
      >
        <h5 className='m-0 text-base font-medium text-customerPrimary-400'>
          {content.data.title}
        </h5>
        <Icon
          name={LucideIconName.CircleX}
          strokeWidth={1.5}
          size={22}
          className={expanded ? '' : 'rotate-45'}
        />
      </div>
      <div
        className={`max-w-[60ch] overflow-hidden px-[0.9rem] transition-all duration-200 ease-in-out [&_h1,_h2,_h3,_h4,_h5,_a,_li,_ul,_ol]:m-0 [&_h1,_h2,_h3,_h4,_h5,_a,_li,_ul,_ol]:mb-[0.7rem] [&_p]:mb-[0.3rem] [&_p]:mt-0 [&_a]:font-inherit [&_a]:text-primary-400 [&_a]:underline ${
          expanded ? 'max-h-[80vh] overflow-y-auto pb-4' : 'max-h-0'
        }`}
        dangerouslySetInnerHTML={{ __html: content.data.content }}
      />
    </div>
  )
}
